import { Component } from "@angular/core";

@Component({
  selector: "evrideo",
  templateUrl: "./content-control-studio-root.component.html",
  styleUrl: "./content-control-studio-root.component.scss",
})
export class ContentControlStudioRootComponent {}
